const RECORDS_KEY = 'cm_mock_records_v3';
const DRAFT_KEY = 'cm_mock_draft_v3';

const delay = (value, ms = 120) => new Promise((resolve) => setTimeout(() => resolve(value), ms));

function readJson(key, fallback) {
  try {
    const value = JSON.parse(localStorage.getItem(key) || 'null');
    return value ?? fallback;
  } catch {
    return fallback;
  }
}

function writeJson(key, value) {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch (error) {
    throw new Error('브라우저 저장공간에 저장하지 못했습니다.', { cause: error });
  }
}

function comparableRecord(record) {
  return JSON.stringify({
    subject: record.subject || {},
    sections: record.sections || {},
  });
}
export const api = {
  async login({ name, institution }) {
    if (!name.trim() || !institution.trim()) throw new Error('성명과 기관명을 입력해 주세요.');
    return delay({ id: `user_${Date.now()}`, name: name.trim(), institution: institution.trim(), role: '담당자' });
  },
  async listRecords() {
    const records = readJson(RECORDS_KEY, []);
    return delay(Array.isArray(records) ? records : []);
  },
  async saveDraft(payload) {
    writeJson(DRAFT_KEY, { ...payload, savedAt: new Date().toISOString(), schemaVersion: 3 });
    return delay({ ok: true });
  },
  async loadDraft() {
    return delay(readJson(DRAFT_KEY, null));
  },
  async clearDraft() {
    localStorage.removeItem(DRAFT_KEY);
    return delay({ ok: true });
  },
  async saveFinal(record) {
    const records = await api.listRecords();
    const managementNo = record.subject?.managementNo;
    const subjectVersions = records
      .filter((item) => item.subject?.managementNo === managementNo)
      .sort((a, b) => (Number(b.version) || 0) - (Number(a.version) || 0) || new Date(b.savedAt) - new Date(a.savedAt));
    const latest = subjectVersions[0];
    if (latest && comparableRecord(latest) === comparableRecord(record)) {
      return delay({ unchanged: true, record: latest });
    }
    const version = (Number(latest?.version) || 0) + 1;
    const saved = {
      ...record,
      id: `rec_${Date.now()}`,
      version,
      status: 'final',
      schemaVersion: 3,
      savedAt: record.savedAt || new Date().toISOString(),
    };
    writeJson(RECORDS_KEY, [saved, ...records]);
    await api.clearDraft();
    return delay({ unchanged: false, record: saved });
  },
  async deleteRecord(id) {
    const records = await api.listRecords();
    writeJson(RECORDS_KEY, records.filter((record) => record.id !== id));
    return delay({ ok: true });
  },
};

export async function reviewSentence({ type, text, service, problem }) {
  const clean = text.trim().replace(/\s+/g, ' ');
  const warnings = [];
  if (clean.length < 10) warnings.push('문장이 다소 짧습니다. 대상, 행동, 확인 방법을 구체화해 보세요.');
  if (/잘|적절히|원활히/.test(clean)) warnings.push('모호한 표현을 횟수·방법·확인 기준으로 구체화해 보세요.');
  let suggestion = clean;
  if (type === 'goal' && clean && !/[.!?]$/.test(clean)) suggestion = `${clean.replace(/다$/, '')}한다.`;
  if (type === 'detail' && clean && !/(확인|점검|모니터링|관찰)/.test(clean)) suggestion = `${clean.replace(/[.]$/, '')}하고, 이후 이용 또는 수행 여부를 확인한다.`;
  return delay({ warnings, suggestion, context: { service, problem } }, 220);
}